import {Transform, Type} from 'class-transformer';

import {EntityArray} from '../../core/entityArray';
import {File} from '../file';
import {Message} from '../messages/message';
import {NativeFile} from '../nativeFile';

import {GroupSetting} from './groupSetting';
import {GroupTag} from './groupTag';

/**
 * Group content
 *
 * @category Group Entity
 * */
export class GroupContent {
  /**
   * Group title, must not be called directly, use {@link Group.getTitle}
   * */
  title: string = null;
  // @todo add group title if group between two user

  /**
   * Group description, can be null
   * */
  description: string;

  /**
   * Group logo.<br>
   * Only images can be added<br>
   * As a logo we can send WebApiFile or our {@link File} entity<br>
   * In case if WebApiFile will be added, it will convert to {@link NativeFile} be uploaded to server and returned as our {@link File} entity<br><br>
   * it also means, that if in attachments there is item with __entity of `WebApiFile`, we need show loader, since it is uploading<br><br>
   *
   * WebApiFile is:<br>
   * https://developer.mozilla.org/en-US/docs/Web/API/File
   * */
  @Type(() => File, {
    discriminator: {
      property: '__entity',
      subTypes: [
        {value: NativeFile, name: 'WebApiFile'},
        {value: File, name: 'File'}
      ],
    },
    keepDiscriminatorProperty: true
  })
  logo: File | NativeFile | any;

  /**
   * Group tags<br>
   * To add new or delete, just added or delete tags to array and send it with edit or create request
   * */
  @Type(() => GroupTag)
  tags: GroupTag[] = [];

  /**
   * Group pinned messages<br>
   * To add new or delete, just added or delete messages to array and send it with edit or create request<br>
   * they must be updates with group change event<br>
   * */
  @Type(() => Message )
  @Transform(({value}) => new PinMessagesCollection(...value))
  pinMessages: PinMessagesCollection = new PinMessagesCollection();

  /**
   * Some group settings,<br>
   * Not implemented yet, for future needs.
   * */
  @Type(() => GroupSetting)
  settings: GroupSetting = new GroupSetting();
}

export class PinMessagesCollection extends EntityArray<Message> {

}
